import { Box, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import { Container } from "@components/Container";
import { Firmness } from "@src/types/strapi/collections";

export interface ProductSoftnessProps {
  softness: Firmness[];
  currentSoftnessId: number;
}

const calculateProgressPercentage = (total: number, target: number): string => {
  const percentage = (target / total) * 100;
  const additionPercentage = 11; // you need add this value to make certeralized bar
  return `${Math.round(percentage) + additionPercentage}%`;
};

export const ProductSoftness = ({
  currentSoftnessId,
  softness,
}: ProductSoftnessProps) => {
  const activeIndex = softness?.findIndex(
    (item) => item.id === currentSoftnessId
  );

  return (
    <Container>
      <VStack width={"full"} maxWidth={{ base: "full", md: "41.2344rem" }}>
        <Box
          width={"full"}
          borderRadius={"1rem"}
          height={{ base: "1rem", md: "21px" }}
          borderColor="gray.600"
          borderWidth={"2px"}
          position="relative"
        >
          <Box
            position={"absolute"}
            top={"-1px"}
            left={"-1px"}
            borderRadius={"10px"}
            height={{ base: "15px", md: "20px" }}
            width={calculateProgressPercentage(softness.length, activeIndex)}
            backgroundColor={"primary.600"}
          />
        </Box>
        <SimpleGrid columns={softness.length} width={"full"}>
          {softness?.map((item) => {
            const isActiveItem = item.id === currentSoftnessId;

            return (
              <VStack key={item.id}>
                <Box
                  height={{ base: "1rem", md: "1.5625rem" }}
                  width={"2px"}
                  backgroundColor={isActiveItem ? "gray.600" : "gray.400"}
                />
                <Text
                  as="span"
                  color={isActiveItem ? "gray.600" : "gray.300"}
                  fontWeight={isActiveItem ? "bold" : "normal"}
                  fontSize={{ base: "0.8rem", md: "1.25rem" }}
                >
                  {item.title}
                </Text>
              </VStack>
            );
          })}
        </SimpleGrid>
      </VStack>
    </Container>
  );
};
